export interface FilterCriteria {
  management_level?: string,
  startDate?: Date,
  endDate?: Date,
  region?: string,
  woreda?: string,
  duration?: string,
  category?: string,
  format?: string,
  reportConfig?: any,
  title?: string;
  isDelete?: boolean;
  isReport?: boolean;
  isMapShow?: boolean;
  formId?: number;
}

export enum FormFields {
  TITLE = 'Title of incident',
  DATE = 'Date',
  MEANS = 'Means',
  INCIDENT_STATUS = 'Incident status',
  STATUS = 'Status',
  REGION = 'Province',
  ZONE = 'District',
  SOURCE_OF_INFO = 'Source of information',
  TARGET = 'Target(s)',
  PRIORITY = 'Priority',
  TYPE_OF_INCIDENT = 'Type of Incident',
  PERPETRATORS = 'Perpetrator(s)',
  ARE_WOMEN_MAIN_TARGET = 'Are women the main target',
  INDICATORS = 'Indicators',
  CLUSTERS = 'Clusters',
  POSTID = 'Post ID'
} 

export interface ReportRecordType {
  fields: FormFields;  
}


